import { render, staticRenderFns } from "./CommandsList.vue?vue&type=template&id=5ced7b9f"
import script from "./CommandsList.vue?vue&type=script&lang=js"
export * from "./CommandsList.vue?vue&type=script&lang=js"
import style0 from "./CommandsList.vue?vue&type=style&index=0&id=5ced7b9f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMenu,QList,QItem,QItemSection,QItemLabel,QIcon,QSeparator});
